import React, { useState, useRef } from "react";
import sendImage from "../../../images/Send.svg";
import { Paperclip, Folder, LayoutTemplate } from "lucide-react";
import { toast, ToastContainer } from "react-toastify";

const MessageInput = ({
  handleSendMessage,
  handleFileSelect,
  setMediaType,
  openMediaLibrary,
  openTemplateModal,
}) => {
  const [message, setMessage] = useState("");
  const [showAttach, setShowAttach] = useState(false);

  const imageInputRef = useRef(null);
  const videoInputRef = useRef(null);
  const documentInputRef = useRef(null);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!message.trim()) {
      toast.warning("Please type a message");
      return;
    }

    handleSendMessage(message.trim());
    setMessage("");
  };

  return (
    <>
<ToastContainer/>
      <form
        onSubmit={handleSubmit}
        className="flex items-center gap-2 border-t p-3 bg-white relative montserrat-font-1"
      >
        {/* Media Library */}
        <button
          type="button"
          onClick={openMediaLibrary}
          className="flex items-center justify-center w-10 h-10 rounded-lg bg-gray-100 hover:bg-gray-200"
        >
          <Folder size={20} className="text-green-600" />
        </button>

        {/* Templates */}
        <button
          type="button"
          onClick={openTemplateModal}
          className="flex items-center justify-center w-10 h-10 rounded-lg bg-gray-100 hover:bg-gray-200"
        >
          <LayoutTemplate size={20} className="text-green-600" />
        </button>

        {/* Attach Dropdown */}
        <button
          type="button"
          onClick={() => setShowAttach(!showAttach)}
          className="flex items-center justify-center w-10 h-10 rounded-lg bg-gray-100 hover:bg-gray-200"
        >
          <Paperclip size={20} className="text-green-600" />
        </button>

        {showAttach && (
          <div className="absolute bottom-14 left-24 bg-white montserrat-font-1 border rounded-lg shadow-lg w-44 z-50">
            <button
              type="button"
              className="block w-full text-left px-3 py-2 hover:bg-gray-100"
              onClick={() => {
                setMediaType("img");
                imageInputRef.current.click();
                setShowAttach(false);
              }}
            >
              🖼 Image
            </button>

            <button
              type="button"
              className="block w-full text-left px-3 py-2 hover:bg-gray-100"
              onClick={() => {
                setMediaType("video");
                videoInputRef.current.click();
                setShowAttach(false);
              }}
            >
              🎥 Video
            </button>

            <button
              type="button"
              className="block w-full text-left px-3 py-2 hover:bg-gray-100"
              onClick={() => {
                setMediaType("pdf");
                documentInputRef.current.click();
                setShowAttach(false);
              }}
            >
              📄 Document
            </button>
          </div>
        )}

        {/* Hidden Inputs */}
        <input
          type="file"
          accept="image/*"
          ref={imageInputRef}
          className="hidden"
          onChange={handleFileSelect}
        />

        <input
          type="file"
          accept="video/*"
          ref={videoInputRef}
          className="hidden"
          onChange={handleFileSelect}
        />

        <input
          type="file"
          accept=".pdf,.doc,.docx,.xls,.xlsx"
          ref={documentInputRef}
          className="hidden"
          onChange={handleFileSelect}
        />

      {/* Message Input */}
<input
  type="text"
  className="flex-1 border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-500"
  placeholder="Type a message"
  value={message}
  onChange={(e) => setMessage(e.target.value)}
/>

{/* Send */}
<button
  type="submit"
  className="ml-2 flex h-10 w-10 items-center justify-center rounded-lg p-0 hover:opacity-90 transition"
>
  <img
    src={sendImage}
    alt="Send"
    className="h-10 w-10 object-contain"
  />
</button>
      </form>
    </>
  );
};

export default MessageInput;